import React, { FC, useMemo } from "react";
import { returnFound } from "find-and";

import { ChartLegend } from "../ChartLegend/ChartLegend";
import { useChartData } from "../../hooks/useChartData";
import { FeatureCardChartProps } from "../../types";

export const FeatureCardChartLegend: FC<FeatureCardChartProps> = ({
  config,
  elementConfig,
  element,
  attributes,
  type,
}) => {
  const { options } = element || {};
  const { twoColumns, chartId, relatedDataSources } = options || {};

  const chartElement = useMemo(
    () => returnFound(elementConfig?.children, { id: chartId }),
    [chartId, elementConfig?.children],
  );

  const { data, loading } = useChartData({
    config,
    element: chartElement,
    attributes,
    type,
  });

  const legendData = useMemo(() => {
    if (!data[0]?.items?.length) return [];

    const relatedAttributes = relatedDataSources || [];
    const isRelated = !!relatedAttributes?.length;

    return isRelated
      ? data[0].items
      : data[0].items.map(item => {
          const attribute = attributes?.find(({ name }) => name === item.name);

          return { ...item, name: attribute?.alias || item.name };
        });
  }, [attributes, data, relatedDataSources]);

  return (
    <ChartLegend data={legendData} loading={loading} chartElement={chartElement} twoColumns={twoColumns} type={type} />
  );
};
